import { useQuery } from '@tanstack/react-query';
import { strapiSearchCustomers } from '../../api/strapiCrm';
import { queryKeys } from '../queryKeys';

const MIN_QUERY_LEN = 1;

export function customersSearchMinLength() {
  return MIN_QUERY_LEN;
}

export function useCustomersSearchQuery(jwt: string | null, q: string) {
  const trimmed = q.trim();

  return useQuery({
    queryKey: queryKeys.customersSearch(jwt, trimmed),
    queryFn: () => strapiSearchCustomers(jwt!, trimmed),
    enabled: Boolean(jwt && trimmed.length >= MIN_QUERY_LEN),
    staleTime: 15_000,
  });
}
